import React, { useEffect } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';

import Navigation from '@app/src/common/components/navigation/Navigation';
import SidebarStore from './SidebarStore';
import SidebarHeader from './SidebarHeader';
import SidebarToggle from './SidebarToggle';
import ModuleSelector from '@app/src/common/components/module-selector/ModuleSelector';

import './Sidebar.scss';

const COLLAPSED_BODY_CLASS = 'app-sidebar-collapsed';
const EXPANDED_BODY_CLASS = 'app-sidebar-expanded';

const Sidebar: React.FC = () => {
  useEffect(() => {
    SidebarStore.hydrate();
  }, []);

  useEffect(() => {
    document.body.classList.toggle(
      COLLAPSED_BODY_CLASS,
      SidebarStore.collapsed
    );
    document.body.classList.toggle(
      EXPANDED_BODY_CLASS,
      !SidebarStore.collapsed
    );
    return () => {
      document.body.classList.remove(COLLAPSED_BODY_CLASS);
      document.body.classList.remove(EXPANDED_BODY_CLASS);
    };
  }, [SidebarStore.collapsed]);

  return (
    <aside
      className={classNames('app-sidebar', {
        'app-sidebar_collapsed': SidebarStore.collapsed,
        'app-sidebar_expanded': !SidebarStore.collapsed
      })}
    >
      <SidebarHeader />
      <div className="app-sidebar__divider" />
      <Navigation />
      <SidebarToggle />
      {SidebarStore.moduleSelectorOpen && <ModuleSelector />}
    </aside>
  );
};

export default observer(Sidebar);
